// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductTypes = (client) => ({
    /**
     * `GET /vendor/product-types`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductTypes
     * @source packages/modules/b2c-core/src/api/vendor/product-types/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-types", { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-types/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductTypeById
     * @source packages/modules/b2c-core/src/api/vendor/product-types/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/product-types/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-types.js.map